import React from "react";

function Heart(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 20"
      enableBackground="new 0 0 16 16"
      x="0px"
      y="0px"
      width="24"
      height="30"
      className="heart"
    >
      <path d="M8 15c-.256 0-.512-.098-.707-.293-.951-.95-2.02-1.695-3.054-2.415-2.18-1.519-4.239-2.952-4.239-5.792 0-3.136 2.149-5.5 5-5.5 1.365 0 2.365.554 3 1.071.635-.517 1.635-1.071 3-1.071 2.944 0 5 2.262 5 5.5 0 2.84-2.059 4.273-4.238 5.792-1.034.72-2.104 1.465-3.055 2.415-.195.195-.451.293-.707.293zm-3-12c-1.767 0-3 1.439-3 3.5 0 1.712 1.222 2.646 3.381 4.15.828.577 1.743 1.214 2.619 1.982.876-.768 1.79-1.405 2.618-1.981 2.16-1.505 3.382-2.439 3.382-4.151 0-1.615-.786-3.5-3-3.5-1.425 0-2.161 1.044-2.168 1.055-.371.557-1.293.557-1.664 0-.024-.035-.754-1.055-2.168-1.055z" />
    </svg>
  );
}

export default Heart;



// WEBPACK FOOTER //
// ./src/components/SVG/Heart.js